module.exports = __webpack_public_path__ + "static/media/DHHS-Logo.35a26d5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/desktop/DHHS-Logo.png
// module id = 158
// module chunks = 0